import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import {
  initializeAppCheck,
  ReCaptchaV3Provider,
  getToken,
} from 'firebase/app-check';

if (!process.env.REACT_APP_FIREBASE_APIKEY) {
  throw new Error('環境変数が取得できませんでした');
}

if (!process.env.REACT_APP_RECAPTCHA_KEY) {
  throw new Error('Recaptcha site keyが取得できませんでした');
}

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_APIKEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTHDOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECTID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDERID,
  appId: process.env.REACT_APP_FIREBASE_APPID,
};

export const firebaseApp = initializeApp(firebaseConfig);
export const auth = getAuth(firebaseApp);
export const firestore = getFirestore(firebaseApp);
export const storage = getStorage(firebaseApp);

// FIREBASE_APPCHECK_DEBUG_TOKEN の定義(TypeScript用)
declare global {
  // eslint-disable-next-line no-var
  var FIREBASE_APPCHECK_DEBUG_TOKEN: boolean | string | undefined;
}

// 1.デバック環境用設定
if (process.env.NODE_ENV === 'development') {
  // Firebase v10ではwindow.selfではなく直接selfを使用
  self.FIREBASE_APPCHECK_DEBUG_TOKEN = true; // デバッグ用文字列の生成
}

// Pass your reCAPTCHA v3 site key (public key) to activate(). Make sure this
// key is the counterpart to the secret key you set in the Firebase console.
try {
  const appCheck = initializeAppCheck(firebaseApp, {
    provider: new ReCaptchaV3Provider(process.env.REACT_APP_RECAPTCHA_KEY),
    isTokenAutoRefreshEnabled: true, // If true, the SDK automatically refreshes App Check
    // tokens as needed.
  });

  getToken(appCheck)
    .then(() => {
      console.log('AppCheck is success.');
    })
    .catch((error) => {
      console.error('AppCheck error:', error);
      // エラーが発生しても認証などの機能が動作するように
      console.log('Continuing despite AppCheck error');
    });
} catch (error) {
  console.error('AppCheck initialization error:', error);
  console.log('Continuing without AppCheck');
}
